import { get, post } from '../../shared/api/client';
import type { components } from '../../shared/api/types.gen';

export type LoginRequest = components['schemas']['LoginRequest'];
export type TokenResponse = components['schemas']['TokenResponse'];
// /auth/me 응답 — id/username/role (사용자 관리용 UserRead와 다른 스키마).
export type AuthUser = components['schemas']['app__schemas__auth__UserRead'];
export type UserRole = components['schemas']['UserRole'];

export const ROLE_LABELS: Record<UserRole, string> = {
  MASTER: '마스터',
  ADMIN: '관리자',
  USER: '사용자',
};

export const login = (body: LoginRequest) => post<TokenResponse>('/auth/login', body);

export const fetchMe = () => get<AuthUser>('/auth/me');
